/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Meta_DescInputs */

const en_mk_meta_desc = /** @type {(inputs: Mk_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan, build, and publish with Bystep. Bring requirements, roadmaps, tasks, AI, verification evidence, and collaboration into one workspace.`)
};

const id_mk_meta_desc = /** @type {(inputs: Mk_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencanakan, bangun, dan terbitkan aplikasi bersama Bystep. Satukan PRD, roadmap, tugas, AI, bukti pemeriksaan, dan kolaborasi dalam satu workspace.`)
};

/**
* | output |
* | --- |
* | "Plan, build, and publish with Bystep. Bring requirements, roadmaps, tasks, AI, verification evidence, and collaboration into one workspace." |
*
* @param {Mk_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_meta_desc = /** @type {((inputs?: Mk_Meta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Meta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_meta_desc(inputs)
	return en_mk_meta_desc(inputs)
});